import styled from "styled-components";

import { Modal } from "components/Modal";

export const ReferralModalContainer = styled(Modal)`
  .modal-dialog {
    max-width: 630px;
  }

  .modal-body {
    h2 {
      font-size: 25px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 2rem;
    }

    .link-wrapper {
      display: flex;
      justify-content: center;
      width: 100%;
      margin-top: 20px;

      .link {
        border: 1px solid ${({ theme }) => theme.input.border.color};
        padding: 9px 12px;
        width: calc(100% - 99px);
        border-top-left-radius: ${({ theme }) =>
          theme.constants.BORDER_RADIUS_8};
        border-bottom-left-radius: ${({ theme }) =>
          theme.constants.BORDER_RADIUS_8};
        border-right: 0;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
      }

      .icon {
        width: 74px;
        background-color: ${({ theme }) => theme.button.bg.primary};
        border-top-right-radius: ${({ theme }) =>
          theme.constants.BORDER_RADIUS_8};
        border-bottom-right-radius: ${({ theme }) =>
          theme.constants.BORDER_RADIUS_8};

        border-color: ${({ theme }) => theme.button.bg.primary};
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 3px 25px;
        cursor: pointer;

        &.copied {
          background-color: ${({ theme }) => theme.constants.COLOR_GREEN};
        }
      }
    }

    .social-media {
      margin-top: 30px;

      .title {
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        margin-bottom: 5px;
      }

      .social-media-icons {
        display: flex;
        justify-content: center;
        gap: 20px;

        .icon-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border-radius: 5px;
          background-color: ${({ theme }) => theme.button.bg.primary};
        }
      }
    }
  }

  @media (max-width: 500px) {
    .modal-body {
      padding: 0;

      .link-wrapper {
        width: 100%;

        .link {
          width: calc(100% - 40px);
          padding: 9px;
        }

        .icon {
          padding: 0;
          width: 40px;
        }
      }
    }
  }
`;
